import Vibrant from './vibrant'
import BrowserImage from './image/browser'

Vibrant.DefaultOpts.ImageClass = BrowserImage

export = Vibrant
